<mat-spinner [diameter]="size"></mat-spinner>